<script lang="ts" setup>
import { computed, nextTick, onMounted, ref, type PropType } from '#imports';
import type { GoodsVO } from '~/types/auto/actuator';
import GoodsItem from './GoodsItem.vue';

defineProps({
  isLimit: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '',
  },
  goodsCount: {
    type: Number,
    default: 0,
  },
  goodsTotal: {
    type: Number,
    default: 0,
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  subTitle: {
    type: String,
    default: '',
  },
  goodsList: {
    type: Array as PropType<GoodsVO[]>,
    default: () => [],
  },
  handleClose: {
    type: Function as PropType<(event: MouseEvent) => void>,
    default: () => {},
  },
});
const goodsListMaxHeight = computed(() => {
  //减去顶栏标题和底部的按钮、关闭按钮信息
  return window.innerHeight - 28 - 24 -20 - (70 + 48 + 40 + 48);
});

const goodsItemHeight = computed(() => {
  const designSize = 200;
  //两行，如果是抽五个时，减去标题和Gap大小信息除以2
  return Math.min((goodsListMaxHeight.value - 78 * 2 - 20) / 2, designSize);
});

const goodsListMaxWidth = computed(() => {
  const maxItemCountPerRow = 4;
  return (
    goodsItemHeight.value * maxItemCountPerRow + 20 * (maxItemCountPerRow - 1)
  );
});
onMounted(() => {});
</script>
<template>
  <div class="flex-center flex-col text-white">
    <h5 class="fade-in animation-delay-500 text-xl font-bold">{{ title }}</h5>
    <h6 class="fade-in animation-delay-500 mt-2 text-xs">{{ subTitle }}</h6>
    <div
      class="mt-5 flex flex-wrap justify-center gap-5"
      :style="{
        maxHeight: goodsListMaxHeight + 'px',
        maxWidth: goodsListMaxWidth + 'px',
      }"
    >
      <GoodsItem
        v-for="item in goodsList"
        :key="item.id"
        :size="goodsItemHeight"
        :animate="false"
        :goods="item"
      />
    </div>
    <div class="fade-in animation-delay-500 flex-center mt-12">
      <p>本期已解锁 {{ goodsCount }}/{{ goodsTotal }}</p>
      <a-divider
        type="vertical"
        class="!top-0 !mx-4 !h-[11px] !border-[rgba(255,255,255,.25)]"
      />
      <p v-if="isLimit">剩余抽谷机会{{ totalCount }}</p>
      <a-divider
        type="vertical"
        class="!top-0 !mx-4 !h-[11px] !border-[rgba(255,255,255,.25)]"
      />
      <NuxtLink
        class="flex-center"
        target="_blank"
        :to="{
          name: 'oj_home_problem',
          query: {
            badge: 1,
          },
        }"
        ><span class="text-white">查看我的谷子</span
        ><img
          class="w-3"
          src="@/assets/image/goods-result-modal/icon-arrow.svg"
      /></NuxtLink>
    </div>
    <div
      class="absolute -bottom-12 left-1/2 -ml-5 cursor-pointer p-2"
      @click="handleClose"
    >
      <img
        class="h-6 w-6"
        src="@/assets/image/goods-result-modal/icon-close.svg"
        alt="close"
      />
    </div>
  </div>
</template>
<style scoped>
.overflow {
  @apply overflow-hidden text-ellipsis whitespace-nowrap;
}
</style>
